import { cmToPx, heightInCm } from 'helpers/utils';
import { currentBrick } from 'helpers/globals';
import style from './FenceElement.module.scss';
import { useMemo } from 'react';

const FenceElementDoor = ({ element }) => {
  const getColumnHeight = useMemo(
    () => cmToPx(heightInCm(element.brickCountVertically)),
    [element.brickCountVertically]
  );

  const generateTopCovers = () => {
    const bricks = [];

    const countOfCovers = Math.ceil(element.width / currentBrick.topCover.width);

    for (let i = 1; i <= countOfCovers; i++) {
      bricks.push(
        <div
          key={i}
          className={`${style.top_cover}`}
          style={{
            width: cmToPx(currentBrick.topCover.width),
            height: cmToPx(currentBrick.topCover.height),
          }}
        >
          <span></span>
        </div>
      );
    }

    return bricks;
  };

  const generateBricks = () => {
    const bricks = [];
    const normalWidth = cmToPx(currentBrick.normalBrick.width);
    const halfWidth = cmToPx(currentBrick.halfBrick.width);

    element.bricks.forEach((brick, index) => {
      bricks.push(
        <div
          key={index}
          className={`${style.brick}`}
          style={{
            width: brick.type === 'normal' ? normalWidth : halfWidth,
            height: cmToPx(currentBrick.halfBrick.height),
          }}
        >
          <div
            className={`${style.brick_inner} ${brick.type === 'connectPrev' ? style['brick_inner-' + brick.type] : ''}`}
            style={{
              width: brick.type === 'half' ? halfWidth : normalWidth,
            }}
          ></div>
        </div>
      );
    });

    return bricks;
  };

  return (
    <>
      <div
        className={`${style.top}`}
        style={{
          height: currentBrick.topCover.height,
          marginLeft: element.name === 'column' ? cmToPx(-2) : 0,
          marginRight: element.name === 'column' ? cmToPx(-2) : 0,
        }}
      >
        {generateTopCovers()}
      </div>
      <div className={`${style.wall}`} style={{ height: getColumnHeight }}>
        {generateBricks()}
      </div>
    </>
  );
};

export default FenceElementDoor;
